import './Block.css'

const Block = ({block, onClick}) => {
    return (
        <div className={`block ${block.hasWon ? "win" : ""}`} onClick={onClick}>
            {block.value}
            {/* {block.id} */}
        </div>
    )
}

export default Block;